<div class="modal-header">
  <h2 class="modal-title mb-0 fs-3 fw-bold" *ngIf="hasTitle">
    {{ title | translate }}
  </h2>
  <button type="button" class="btn-close" (click)="bsModalRef.hide()" [attr.aria-label]="'button.close' | translate"></button>
</div>
<div class="modal-body">
  <p class="text-center">{{ message | translate }}</p>
  <div class="d-flex justify-content-center align-items-center p-3">
    <i class="bi bi-exclamation-circle-fill fs-1"></i>
  </div>
</div>
